import { blobResponse } from "Components/constants/Common";
import { ADD_EDIT_TAX_INVOICE, TAX_INVOICE_LIST, TAX_INVOICE_PDF, WORK_ORDER_TAX_INVOICE } from "./ApiRoutes";
import { authData } from "./services";

export const listOfTaxInvoice = async (data: object) => {
    const response = await authData.post(TAX_INVOICE_LIST, data);
    return response?.data;
};

export const addTaxInvoice = async (data: object) => {
    const response = await authData.post(ADD_EDIT_TAX_INVOICE, data);
    return response?.data;
};

export const viewTaxInvoice = async (id: number) => {
    const response = await authData.get(`${ADD_EDIT_TAX_INVOICE}/${id}`);
    return response?.data;
};

export const editTaxInvoice = async (id: number, data: object) => {
    const response = await authData.put(`${ADD_EDIT_TAX_INVOICE}/${id}`, data);
    return response?.data;
};
export const taxInvoicePdfApi = async (id: number) => {
  const response = await authData.get(`${TAX_INVOICE_PDF}${id}`, blobResponse);
  return response;
};
export const workOrderTaxInvoiceApi = async () => {
  const response = await authData.get(WORK_ORDER_TAX_INVOICE);
  return response?.data;
};